import * as React from 'react';

const TariffFiber = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='18'
    viewBox='0 0 22 18'
    fill='none'
    {...props}
  >
    <path
      d='M18.0585 13.3836H3.94389C2.78933 13.3836 1.81064 12.5434 1.66536 11.4281L0.51845 2.50571C0.434343 1.87371 0.640787 1.23427 1.07661 0.75097C1.51244 0.275108 2.13942 0 2.79698 0H19.2054C19.863 0 20.49 0.275108 20.9258 0.75097C21.3616 1.23427 21.5604 1.86627 21.484 2.50571L20.3371 11.4281C20.1918 12.5434 19.2131 13.3836 18.0585 13.3836Z'
      fill='#FF0037'
    />
    <path
      d='M18.4638 17.25C13.6162 16.0678 8.3939 16.0678 3.54629 17.25L3.17164 15.8075C8.26392 14.5658 13.7461 14.5658 18.8384 15.8075L18.4638 17.25Z'
      fill='#FF0037'
    />
  </svg>
);

export default TariffFiber;
